import { createReducer } from "reduxsauce"
import { get, omit } from "lodash"
import actionCreator from "helpers/actionCreator"
import { takeLatest, select, put } from "redux-saga/effects"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { Types as HistoryTypes } from "../../../actions/app/history"
import { getCategoryItemsSubset } from "./selectors/data"

export const { Types, Creators } = actionCreator("ompnt/modules/securityProfileForecast", {
  toggle: {
    props: ["id", "currentState"],
    track: true,
    trackType: "security-profile-forecast-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setSelectedCategory: {
    props: ["category"],
    track: true,
    trackType: "security-profile-forecast-category-selection",
    trackPayload: ({ category }) => ({ type: category }),
  },
  toggleOnly: {
    props: ["id", "state", "contentSetId"],
    track: true,
    trackType: "security-profile-forecast-graph-legend-factor",
    trackPayload: ({ id, state }) => ({ factor: id, state }),
  },
  toggleOnlySuccess: ["selected", "only", "items"],
})

const DEFAULT_STATE = {
  selectedCategory: null,
  focusedChartLine: null,
  disabled: {},
  only: null,
}

function handleSetSelectedCategory(state, { category }) {
  return {
    ...state,
    selectedCategory: category,
    only: null,
  }
}

function handleToggle(state, { id }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id
    disabled = omit(state.disabled, id)
  } else {
    focusedChartLine = null
    disabled = { [id]: true, ...state.disabled }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleNavigate(state, action) {
  if (get(action, "location.query.security", null)) {
    return { ...state, selectedCategory: null, focusedChartLine: null }
  } else {
    return state
  }
}

function handleToggleOnlySuccess(state, { selected, only, items }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected
    items.forEach(item => {
      if (item.id !== selected) {
        disabled[item.id] = true
      }
    })
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_SELECTED_CATEGORY]: handleSetSelectedCategory,
  [HistoryTypes.NAVIGATE]: handleNavigate,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
})

function* handleToggleOnly({ id, contentSetId }) {
  const { items, only } = yield select(state => ({
    items: getCategoryItemsSubset(state, { contentSet: contentSetId }),
    only: state.modules.securityProfileForecast.only,
  }))

  yield put(Creators.toggleOnlySuccess(id, only !== id, items))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
